/*jshint esversion:8*/
import {
    isCustomEnterprisePlan,
    isFreePlan,
    isSelfServePaidPlan,
    isTrialPlan,
    isFreeOrTrialPlan,
    getWorkspaceSettingsForPlan
} from "./plans/utilities";
import { Plan } from "./plans/types";
import {
    MONTHLY_PRICE_PER_CREDIT,
    ANNUAL_PRICE_PER_CREDIT,
    STANDARD_PRICE_PER_CREDIT_USD
} from "./plans/information";
import { featureFlagInformation } from "./plans/info/featureFlags";

// Backward compatibility exports
// These functions are now wrappers around the new system

function getSettingsForUninitializedWorkspace(features = {}) {
    return getWorkspaceSettingsForPlan(Plan.UninitalizedWorkspace, features.creditSystem);
}

function getSettingsForPublicPlan(features = {}) {
    return getWorkspaceSettingsForPlan(Plan.Public, features.creditSystem);
}

function getSettingsForSandboxPlan(features = {}) {
    return getWorkspaceSettingsForPlan(Plan.LegacySandbox, features.creditSystem);
}

function getSettingsForStarterPlan(features = {}) {
    return getWorkspaceSettingsForPlan(Plan.LegacyStarter, features.creditSystem);
}

function getSettingsForResearchPlan(selectedPlan, features = {}) {
    return getWorkspaceSettingsForPlan(Plan.Research, features.creditSystem, selectedPlan);
}

function getSettingsForGrowthTrial(features = {}) {
    return getWorkspaceSettingsForPlan(Plan.UbpPremiumTrial, features.creditSystem);
}

/**
 * Returns feature flag overrides that should be applied when changing to a plan.
 * This replaces the old featureFlagOverridesForPlanChange function.
 * @param {string} plan - The plan to get feature overrides for
 * @returns {object} Feature flags object with overrides
 */
function featureFlagOverridesForPlanChange(plan) {
    const planSettings = getWorkspaceSettingsForPlan(plan);
    const overrides = Object.values(featureFlagInformation).filter(
        (flag) => flag.applyPlanChangeOverrideInAdmin
    );

    return overrides.reduce((acc, flag) => {
        const value = planSettings.features?.[flag.id];
        if (value !== undefined) {
            acc[flag.id] = value;
        }
        return acc;
    }, {});
}

export {
    getSettingsForUninitializedWorkspace,
    getSettingsForPublicPlan,
    getSettingsForSandboxPlan,
    getSettingsForStarterPlan,
    getSettingsForResearchPlan,
    getSettingsForGrowthTrial,
    getWorkspaceSettingsForPlan,
    isCustomEnterprisePlan,
    isFreePlan,
    isTrialPlan,
    isFreeOrTrialPlan,
    isSelfServePaidPlan,
    featureFlagOverridesForPlanChange,
    MONTHLY_PRICE_PER_CREDIT,
    ANNUAL_PRICE_PER_CREDIT,
    STANDARD_PRICE_PER_CREDIT_USD
};
export default {
    getSettingsForUninitializedWorkspace,
    getSettingsForPublicPlan,
    getSettingsForSandboxPlan,
    getSettingsForStarterPlan,
    getSettingsForResearchPlan,
    getSettingsForGrowthTrial,
    getWorkspaceSettingsForPlan,
    isCustomEnterprisePlan,
    isFreePlan,
    isTrialPlan,
    isFreeOrTrialPlan,
    isSelfServePaidPlan,
    featureFlagOverridesForPlanChange,
    MONTHLY_PRICE_PER_CREDIT,
    ANNUAL_PRICE_PER_CREDIT,
    STANDARD_PRICE_PER_CREDIT_USD
};
